module.exports = __webpack_public_path__ + "static/media/right-arrow.2215adf1.svg";